export type EpochSeconds = number; // unix timestamp, in seconds

export const getEpochSeconds = () =>
  Math.floor(Date.now() / 1000) as EpochSeconds;

// Determines if two dates are equal. Does not compare their times, just the
// dates.
export function datesEqual(
  stampA: EpochSeconds,
  stampB: EpochSeconds
): boolean {
  const formatForComparison = (d: Date): string => {
    // not pretty, just used for comparison
    return `${d.getUTCFullYear()}-${d.getUTCMonth()}-${d.getUTCDate()}`;
  };

  const dateA = new Date(stampA * 1000);
  const dateB = new Date(stampB * 1000);

  return formatForComparison(dateA) === formatForComparison(dateB);
}

// Returns the number of days from start to end. If end is before start, will
// return zero. Rounds down.
export function numDaysUntil(start: EpochSeconds, end: EpochSeconds): number {
  const secondsPerDay = 86400;

  const result = Math.floor((end - start) / secondsPerDay);

  return result >= 0 ? result : 0;
}
